module.exports = __webpack_public_path__ + "img/3.31a26f31.jpg";